export default __webpack_public_path__ + "static/media/jasmin1.9607908b.jpg";